import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { DataService, IData } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class FacadeService {
  // tslint:disable-next-line: variable-name
  private _dataService!: DataService;
  public get dataService(): DataService {
    if (!this._dataService) {
      this._dataService = this.injector.get(DataService);
    }
    return this._dataService;
  }
  
  constructor(private injector: Injector) { }
  
  getData(): Observable<IData> {
    return this.dataService.getData();
  }

  getFirstLoginError(): Observable<any> {
    return this.dataService.getFirstLoginError();
  }

  getContact(): Observable<any> {
    return this.dataService.getContact();
  }

  getOrder(): Observable<any> {
    return this.dataService.getOrder();
  }
}